<script>
const TheAchievementTableForStatementScholarship = () => import("../../Tables/TheAchievementTableForStatementScholarship.vue");
export default {
  name: "TheMainCardSchCompetition",

  props:{
    achievements: Array,
    selectedAchievements: Array,
    loadingListAchievements: {
      type: Boolean,
    }
  },

  components: {
    TheAchievementTableForStatementScholarship,
  },


  methods: {
    selectAchievement(achievements) {
      this.$emit('select', achievements)
    },
  },

}
</script>

<template>
  <v-card
    flat
    outlined
    rounded="xl"
    class="pb-3"
  >
    <v-card-title>
      Список достижений доступных для заявления
      <v-spacer></v-spacer>

      <v-btn
        icon
        :loading="loadingListAchievements"
        @click="$emit('refresh')"
      >
        <v-icon>fa-spinner</v-icon>
      </v-btn>
    </v-card-title>

    <the-achievement-table-for-statement-scholarship
      :achievements="achievements"
      :selected-achievements="selectedAchievements"
      @select="selectAchievement"
    />
  </v-card>
</template>

<style scoped>

</style>